import React from 'react'
import { CALCULATION_METHODS } from '../../pages/event-feeds/visualization-panel/highlights/geo/index.jsx'

import ScaleSvg from './scale.svg'
import ScaleIndexSvg from './scale-index.svg'

import './styles.scss'
import classNames from 'classnames'

const GeoLegend = ({ className, calculationMethod, start, middle, end }) => {
  return (
    <div className={classNames(className, 'geo-legend__container')}>
      <div className="geo-legend__values">
        <span>{start}</span>
        <span>{middle}</span>
        <span>{end}</span>
      </div>
      <If
        condition={
          calculationMethod === CALCULATION_METHODS.EVENTS ||
          calculationMethod === CALCULATION_METHODS.PER_CAPITA ||
          calculationMethod === CALCULATION_METHODS.UNIQUE_USERS ||
          calculationMethod === CALCULATION_METHODS.UNIQUE_USERS
        }
      >
        <ScaleSvg className="geo-legend__scale" />
      </If>
      <If condition={calculationMethod === CALCULATION_METHODS.INDEX}>
        <ScaleIndexSvg className="geo-legend__scale" />
      </If>
    </div>
  )
}

export default GeoLegend
